import React from 'react';
import { useIntl } from 'react-intl';
import CHTable from '../../../../components/CHComponents/CHTable';
import './Table.css';
import { isMobile } from 'react-device-detect';

const Table = props => {
	const intl = useIntl();

	const columns = [
		{id: 0, label: intl.formatMessage({id: 'general.date', defaultMessage: 'Date'})},
		{id: 1, label: intl.formatMessage({id: 'general.type', defaultMessage: 'Type'})},
		{id: 2, label: intl.formatMessage({id: 'general.message', defaultMessage: 'Message'})},
	];

	return (
		<CHTable tableClassName={(isMobile?"mobile-":"browser-")+"userSalesTable-userNotifications"}
			columns={columns}
			rows={[]}
		/>
	);
};

export default Table;
